export default class ChangeElementTextAction {
    constructor(elementId, text) {
        this.elementId = elementId;
        this.text = text;
        this.type = 'changeElementText';
        this.time = Date.now();
        this.textBefore = null;
    }
    apply(state, dom, logger) {
        return {
            idsToEvaluate: this.changeText(state, dom, this.text)
        };
    }
    undo(state, dom, logger) {
        if (null !== this.textBefore) {
            return {
                idsToEvaluate: this.changeText(state, dom, this.textBefore)
            };
        }
        return {
            idsToEvaluate: []
        };
    }
    getDataToMergeWithNext(nextType) {
        return {};
    }
    mergeWithPrevious(previousType, previousData) {
        return false;
    }
    changeText(state, dom, textToSet) {
        const element = state.elements.getById(this.elementId);
        if (!element) {
            return [];
        }
        if (null === this.textBefore) {
            this.textBefore = element.getText();
        }
        const textUpdateResult = element.updateText(textToSet);
        if (textUpdateResult.renderNeeded || textUpdateResult.textChanged) { // We don't need to sync text as a result of regular character changes, but when we need to re-render for emphasis or change text based on actions like splitting elements.
            const selection = dom.getSelection();
            element.syncText(dom.getById(element.getId()));
            if (selection) {
                dom.setSelection(selection);
            }
        }
        if (textUpdateResult.intrinsicTypeAfter !== textUpdateResult.intrinsicTypeBefore) {
            return [element.getId()];
        }
        return [];
    }
}
